import { WebviewAddress } from '@gitlab-org/webview-plugin';
import { MessageBus } from './message_bus';

export type NotificationMessage = WebviewAddress & {
  type: string;
  payload?: unknown;
};

export type RequestMessage = NotificationMessage & {
  requestId: string;
};

export type SuccessfulResponse = WebviewAddress & {
  requestId: string;
  success: true;
  type: string;
  payload?: unknown;
};

export type FailedResponse = WebviewAddress & {
  requestId: string;
  success: false;
  reason: string;
  type: string;
};

export type ResponseMessage = SuccessfulResponse | FailedResponse;

export type Messages = {
  'webview:connect': WebviewAddress;
  'webview:disconnect': WebviewAddress;
  'webview:notification': NotificationMessage;
  'webview:request': RequestMessage;
  'webview:response': ResponseMessage;
  'plugin:notification': NotificationMessage;
  'plugin:request': RequestMessage;
  'plugin:response': ResponseMessage;
};

export class WebviewRuntimeMessageBus extends MessageBus<Messages> {}
